module.exports = __webpack_public_path__ + "b09d1782d881a87304555c8fd370ac27.svg";